import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { listProjects } from '../../Accounts/API'
import { getProjectState as getProjectStateConnect } from '../../../actions/savedState'
import { setDialog as setDialogConnect } from '../../../actions/navigation'
import Modal from '../Modal'
import SVGWrapper from '../../SVGWrapper'
import TrashIcon from '../../../../img/icon-trash.svg'
import Clipboard from '../../../../img/icon-survey.svg'
import CloudDownloadIcon from '../../../../img/icon-cloud-download.svg'
import Accordion from '../../Accordion'

const ProjectLoad = ({ getProjectState, selected, setDialog }) => {
    const [projects, setProjects] = useState([])
    const [selectedProject, setSelectedProject] = useState(selected) // uuid
    const [isLoading, setIsLoading] = useState(false)
    const [copied, setCopied] = React.useState(false)

    useEffect(() => {
        const getList = async () => {
            setIsLoading(true)
            const projectArray = await listProjects()
            setProjects(projectArray)
            setIsLoading(false)
        }

        getList()
    }, [])

    const onLoad = async uuid => {
        setIsLoading(true)

        await getProjectState(uuid)

        setIsLoading(false)
        setDialog('')
    }

    const onSelectProject = uuid => {
        if (uuid === selectedProject) {
            setSelectedProject('')
            return
        }
        setSelectedProject(uuid)
    }

    const onCopy = () => {
        setCopied(true)
        setTimeout(() => setCopied(false), 8000)
    }

    return (
        <Modal>
            <header>
                <h2 className="title">Saved Projects</h2>
            </header>
            {!projects.length && <div>You currently have no saved projects.</div>}
            <div style={{ width: '400px' }}>
                <Accordion
                    content={projects
                        .sort((projectA, projectB) => {
                            const dateA = new Date(projectA.modify_date)
                            const dateB = new Date(projectB.modify_date)
                            return dateB.valueOf() - dateA.valueOf()
                        })
                        .map(project => {
                            const { uuid, modify_date, name } = project
                            const baseDate = new Date(modify_date)
                            const modifyDate = new Intl.DateTimeFormat('en-US').format(baseDate)
                            const url = `${window.location.origin}/projects/${uuid}`

                            return {
                                open: selectedProject === uuid,
                                id: uuid,
                                onClick: () => onSelectProject(uuid),
                                heading: (
                                    <p>
                                        <span className="is-static-size-4 is-bold is-block">{name}</span>
                                        <span className="is-static-size-7 is-italic is-block">
                                            Last modified: {modifyDate}
                                        </span>
                                    </p>
                                ),
                                body: (
                                    <div>
                                        <div>Share URL: &nbsp;{url}</div>
                                        <p>
                                            Share URL allows anyone who visits the URL to view this project. Only the
                                            owner (you) can overwrite or delete this project.
                                        </p>
                                        <div className="space-between" style={{ marginBottom: '2px' }}>
                                            <button
                                                onClick={() => setDialog('projectDelete', { uuid, name })}
                                                className="button is-danger is-small"
                                                disabled={isLoading}
                                                type="button"
                                            >
                                                <SVGWrapper title="Trash Icon" fill="white">
                                                    <TrashIcon width={12} height={12} />
                                                </SVGWrapper>{' '}
                                                &nbsp; Delete
                                            </button>
                                            <CopyToClipboard text={url} onCopy={onCopy}>
                                                <button
                                                    className="button is-neutral is-small"
                                                    disabled={isLoading}
                                                    type="button"
                                                >
                                                    <span className="clip-icon">
                                                        <Clipboard
                                                            style={{
                                                                height: '18px',
                                                                width: '18px',
                                                                margin: '3px 0px 0px 0px'
                                                            }}
                                                        />
                                                    </span>
                                                    &nbsp; {copied ? 'Copied' : 'Copy Share URL'}
                                                </button>
                                            </CopyToClipboard>
                                            <button
                                                onClick={() => onLoad(uuid)}
                                                className="button is-primary is-small"
                                                disabled={isLoading}
                                                type="button"
                                            >
                                                <SVGWrapper title="Load Icon" fill="white">
                                                    <CloudDownloadIcon width={14} height={14} />
                                                </SVGWrapper>{' '}
                                                &nbsp; Load
                                            </button>
                                        </div>
                                    </div>
                                )
                            }
                        })}
                />
            </div>
        </Modal>
    )
}

ProjectLoad.propTypes = {
    // parent props
    selected: PropTypes.string,
    // redux actions
    getProjectState: PropTypes.func.isRequired,
    setDialog: PropTypes.func.isRequired
}

ProjectLoad.defaultProps = {
    selected: ''
}

const mapStateToProps = state => ({ state })

export default connect(mapStateToProps, dispatch => ({
    getProjectState: hash_input => dispatch(getProjectStateConnect(hash_input)),
    setDialog: (dialogName, dialogProps) => dispatch(setDialogConnect(dialogName, dialogProps))
}))(ProjectLoad)
